import { render, staticRenderFns } from "./centerLeft3.vue?vue&type=template&id=570d2478&scoped=true&"
import script from "./centerLeft3.vue?vue&type=script&lang=js&"
export * from "./centerLeft3.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft3.vue?vue&type=style&index=0&id=570d2478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d2478",
  null
  
)

export default component.exports